import AllocatedProjectList from "./allocatedProjectList";
export default AllocatedProjectList;